import React, { FC } from 'react';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material';
import {
  CommonProps,
  ICategory,
  minimalTableColumns,
  tableColumns,
} from './constants';

export const TableHeader: FC<CommonProps> = ({
  isMinimal,
  order = 'asc',
  orderBy = 'name',
  handlers,
}) => {
  const createSortHandler = (property: keyof ICategory) => () => {
    const isAsc = orderBy === property && order === 'asc';
    handlers?.onSortChange?.(property, isAsc ? 'desc' : 'asc');
  };

  return (
    <TableHead>
      <TableRow>
        {[...(isMinimal ? minimalTableColumns : tableColumns)].map((column) => (
          <TableCell
            key={column.id}
            align={column.align || 'center'}
            sortDirection={
              column.sortable && orderBy === column.id ? order : false
            }
            style={{
              minWidth: column.minWidth || 100,
              width: column.width || 'unset',
            }}
          >
            {!column.sortable || !handlers?.onSortChange ? (
              <Typography variant="body2">{column.label}</Typography>
            ) : (
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : 'asc'}
                onClick={createSortHandler(column.id)}
              >
                {column.label}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
        {handlers && <TableCell align="center">Actions</TableCell>}
      </TableRow>
    </TableHead>
  );
};
